module.exports = __webpack_public_path__ + "img/logo2---.6a19b4ca.png";